import { withForm } from '@/components/form';
import { SectionCard } from '@/components/ui';

import { defaultFormValues } from '../../contactSchema';

export const ConsentsSection = withForm({
  defaultValues: defaultFormValues,
  render: function ConsentsSection({ form }) {
    return (
      <SectionCard title="Consents">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <form.AppField name="consents.marketing">
            {(field) => <field.Checkbox label="Marketing — emails, newsletters, promotions" />}
          </form.AppField>
          <form.AppField name="consents.analytics">
            {(field) => <field.Checkbox label="Analytics — behavior tracking, attribution" />}
          </form.AppField>
          <form.AppField name="consents.thirdParty">
            {(field) => <field.Checkbox label="Third-party — sharing with partners" />}
          </form.AppField>
        </div>
      </SectionCard>
    );
  },
});
